import { render, staticRenderFns } from "./q-table.vue?vue&type=template&id=1b78a3d0"
import script from "./q-table.vue?vue&type=script&lang=ts"
export * from "./q-table.vue?vue&type=script&lang=ts"
import style0 from "./q-table.vue?vue&type=style&index=0&id=1b78a3d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports